import React, { Component, Fragment } from 'react';
import './thankyou.css';
import { updateObject } from "../../js/actions/index";
import store from "../../js/store/index";
import Form from 'react-bootstrap/Form'

function mapDispatchToProps(dispatch) {
  return {
    updateObject: article => dispatch(updateObject(article)),
  };
}

class Thankyou extends Component {

  constructor(props) {
    super(props);
    console.log(props);
    this.state = { appState: store.getState() };
    this.haartSearch = this.haartSearch.bind(this)
  }

  componentDidMount() {
  }

  handleChange(event) {
  }

  haartSearch() {
    window.location = 'https://www.haart.co.uk/buying/';
    console.log('go to haart');
  }

  render() {
    return (
      <Fragment>
        <div className="row valFormWidth" style={{ background: 'transparent', padding: '20px 30px', opacity: '0.95', margin: '0 auto' }}>
          <div className="row pageHeader" style={{ width: '100%' }}>
              <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: '10px', paddingLeft: '0px'}}>
                  <label style={{fontWeight: 'bold', marginBottom: '0px'}}>Thank you</label>
              </div>
          </div>
          <div className="row pageSubHeader">
            <div className="col-md-12 col-sm-12 col-xs-12" style={{ paddingBottom: '10px', paddingLeft: '0px'}}>
              <label style={{ fontWeight: 'bold' }}>These extra details will help us to find you the right property</label>
            </div>
          </div>
          <div style={{ background: 'white', textAlign: 'center', border: '1.1px solid lightgray', borderRadius: '16px', marginTop: '15px', width: '100%' }}>
            <Form style={{ padding: '30px' }}>
              <div className="row" style={{ margin: '10px auto', color: '#401663', width: '80%', fontWeight: 'bold', marginBottom: '0px', display: 'inline' }}>
                <p style={{ marginBottom: '10px' }}>We will be in touch with you shortly to discuss your needs</p>
              </div>
              <div className="row" style={{ margin: '10px auto', color: '#401663', width: '80%', fontWeight: 'bold', marginBottom: '0px', display: 'inline' }}>
                <p style={{ marginBottom: '10px' }}>In the meantime why not take a look at the properties on the market near you</p>
              </div>
              <div className="row" style={{ width: '50%', margin: '40px auto 0px', borderRadius: '32px' }}>              
                <div onClick={() => { this.haartSearch() }} className="form-control" style={{ borderRadius: '32px', borderLeft: 'none', marginBottom: '20px', height: '50px', paddingTop: '10px', background: '#ec008c' }}>
                  <a style={{ color: 'white', fontWeight: 'bold' }} type="button">FIND YOUR NEXT HOME</a>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Thankyou;